export interface KeyValueCache<T> {
  get(key: string | number): T | undefined;
  set(key: string | number, value: T): void;
}

export function createCache<T>(): KeyValueCache<T> {
  const map = new Map<string | number, T>();

  return {
    get(key: string | number) {
      return map.get(key);
    },
    set(key: string | number, value: T) {
      return map.set(key, value);
    },
  };
}
